/** Operator-facing copy when the PCBA prefix has no Kodiak planned assignment. */
export function configurationPcbaPrefixNoAssignmentMessage(pcbaPrefix: string | null | undefined): string {
  const prefix = (pcbaPrefix ?? "").trim();
  if (prefix === "") {
    return (
      "This PCBA serial prefix has no TLA assignment. " +
      "If you think this was in error, contact a supervisor."
    );
  }
  return (
    `PCBA prefix ${prefix} has no TLA assignment for this job. ` +
    "If you think this was in error, contact a supervisor."
  );
}

/** Operator-facing copy when Kodiak PCBA prefix assignment blocks configure. */
export function configurationPcbaPrefixBlockMessage(
  lockedTlaSku: string | null | undefined,
  requiredTlaSku: string | null | undefined,
): string {
  const locked = (lockedTlaSku ?? "").trim();
  const required = (requiredTlaSku ?? "").trim();
  if (locked === "" || required === "") {
    return (
      "PCBA serial prefix is locked to a different TLA than this job. " +
      "If you think this was in error, contact a supervisor."
    );
  }
  return (
    `PCBA serial prefix is locked to ${locked} and this job is for ${required}. ` +
    "If you think this was in error, contact a supervisor."
  );
}
